import {
  Grid,
  GridItem,
  Nowrap,
  Picture,
  Text,
  useViewport,
} from '@farmersdog/corgi-x';
import { ExtendedText } from '../../../../components';
import { bowlPackDesktopSources, bowlPackMobileSources } from './assets';
import styles from './VetsNegativeBowlPackSection.module.css';

export const VetsNegativeBowlPackSection = () => {
  const viewport = useViewport();
  const isMobile = !viewport.lg;

  return (
    <Grid className={styles.wrapper} gap={{ xs: 'none', lg: 'xl' }}>
      <GridItem lg={6} className={styles.headingsContainer}>
        <div className={styles.titleContainer}>
          <ExtendedText
            variant={isMobile ? 'heading-28' : 'heading-36'}
            as="h2"
            id="bowl-pack-section-heading"
            weight="black"
            color="Kale3"
          >
            You shouldn’t be the only <Nowrap>one eating healthy</Nowrap>
          </ExtendedText>
        </div>
        <div className={styles.subtitleContainer}>
          <Text
            variant={isMobile ? 'heading-16' : 'heading-22'}
            as="p"
            color="Kale3"
          >
            We love our pets and care about their health. <br />
            That’s why we started The Farmer’s Dog: <br />
            to make a smarter, healthier pet food.
          </Text>
        </div>
      </GridItem>
      <GridItem
        direction={isMobile ? 'column' : 'row-reverse'}
        justify={isMobile ? 'center' : 'flex-end'}
        alignItems="center"
      >
        <div className={styles.imageContainer}>
          <Picture
            sources={[...bowlPackMobileSources, ...bowlPackDesktopSources]}
            alt="Turkey Bowl"
            loading="lazy"
            className={styles.bowlImage}
          />
        </div>
      </GridItem>
    </Grid>
  );
};
